"use client";

import { c as _c } from "react/compiler-runtime";
import { useForm } from "@tanstack/react-form";
import { useAlertContext } from "@/providers/context.provider";
import { LoginComponent } from "@/components/auth/login/login.component";
import { hostLoginAction } from "@/serverActions/auth.action";
import { setSentryUser } from "@/utils/sentry.util";
import type { TLoginForm } from "@/types/auth.type";
export const LoginContainer = () => {
  const $ = _c(5);
  const {
    showAlert
  } = useAlertContext();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      email: "",
      password: ""
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== showAlert) {
    t1 = {
      defaultValues: t0,
      onSubmit: async t2 => {
        const {
          value
        } = t2;
        const {
          email,
          password
        } = value;
        const result = await hostLoginAction({
          email,
          password
        });
        if (typeof result === "string" && result.includes("Invalid credentials")) {
          showAlert("Invalid credentials", false);
          return;
        }
        if (result && typeof result !== "string" && "user" in result) {
          setSentryUser({
            id: (result as any).user?.id || "unknown",
            username: (result as any).user?.username || email,
            email,
            role: "host"
          });
        }
      }
    };
    $[1] = showAlert;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const form = useForm(t1);
  let t2;
  if ($[3] !== form) {
    t2 = <LoginComponent form={form} />;
    $[3] = form;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
};